export { default } from 'ember-cli-head/components/head-layout';
